"use client";

import { SignInFormVariant, SignInVariant } from "./SignInSignUpForm";

import { FacebookIcon } from "../common/icons";
import { IconProps } from "../common/icons";
import SignInButton from "./SignInButton";
import { cn } from "@punchup/utils/cn";

interface Props {
  name: string;
  value: SignInVariant;
  variant?: SignInFormVariant;
  className?: string;
}

export default function FacebookSignInButton({
  name,
  value,
  variant = "normal",
  className,
}: Props) {
  return (
    <SignInButton
      name={name}
      value={value}
      label="Sign in with Facebook"
      Icon={StyledFacebookIcon}
      variant={variant}
      className={className}
    />
  );
}

const StyledFacebookIcon = ({ className }: IconProps) => {
  return <FacebookIcon className={cn("text-primary-blue", className)} />;
};
